import { RoomInterface } from './../types/talkRoomTypes';
import { GET_TALKROOM } from '../constants/index';
import {
  TalkRoomState,
  talkRoomActions
} from '../types/talkRoomTypes'

const initialState: TalkRoomState = {
  walks: [] as RoomInterface[]
}

const talkRoomReducer = (state = initialState, action: talkRoomActions) => {
  const payload = action.payload

  switch(action.type){
    case GET_TALKROOM:    
      const newPayload = state.walks.concat(payload)
      const exists = state.walks.filter((room: RoomInterface) => room.room === payload.room) ? state.walks.map((room: RoomInterface) => {
        if(room.room === payload.room) {
          return {
            ...room,
            walk: payload.walk,
            room: payload.room,
            participant_count: payload.participant_count
          }
        } else {
          return room
        }
      }) : newPayload
      
      return {
        ...state,
        walks: state.walks.length > 0 ? exists : newPayload
      }

    default: 
      return state
  }
}

export default talkRoomReducer;